export default __webpack_public_path__ + "static/media/H4003.03a4664e.mp3";